import { HttpMethods, makeRequest } from '../helpers/http.helper';
import { LoginRequest, RegisterRequest, RefreshTokenRequest, UpdateUserRequest, ResetPasswordRequest, ForgotPasswordRequest } from '../types/auth.type';

export const loginUser = (user: LoginRequest) => {
    return makeRequest({
        url: "/user/login",
        method: HttpMethods.POST,
        data: user,
    });
};

export const registerUser = (data: RegisterRequest) => {
    return makeRequest({
        url: "/user/register",
        method: HttpMethods.POST,
        data,
    });
};

export const refreshToken = (data: RefreshTokenRequest) => {
    return makeRequest({
        url: "/app_user/refresh_token",
        method: HttpMethods.POST,
        data,
    });
};

export const getCurrentUser = () => {
    return makeRequest({
        url: "/user/me",
        method: HttpMethods.GET,
    });
};

export const getUsers = (organizationId: string) => {
    return makeRequest({
        url: `/user/${organizationId}`,
        method: HttpMethods.GET,
    });
};

export const updateUser = (organizationId: string, userId: string, data: UpdateUserRequest) => {
    return makeRequest({
        url: `/user/${organizationId}/${userId}`,
        method: HttpMethods.PUT,
        data,
    });
};

export const replaceUserCollectionSites = (
    organizationId: string,
    userId: string,
    collection_site_ids: string[]
) => {
    return makeRequest({
        url: `/user/${organizationId}/${userId}/sites`,
        method: HttpMethods.PUT,
        data: { collection_site_ids },
    });
};

export const forgotPassword = (data: ForgotPasswordRequest) => {
    return makeRequest({
        url: "/user/forgot-password",
        method: HttpMethods.POST,
        data,
    });
};

export const resetPassword = (data: ResetPasswordRequest) => {
    return makeRequest({
        url: "/user/reset-password",
        method: HttpMethods.POST,
        data,
    });
};
